import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-project-type-view',
    template: `
    <small class="tag">
      <ng-container [ngSwitch]="code">
        <ng-container *ngSwitchCase="'CAPITAL_REPAIR'" i18n>Капитальный ремонт</ng-container>
        <ng-container *ngSwitchCase="'MEDIUM_REPAIR'" i18n>Средний ремонт</ng-container>
        <ng-container *ngSwitchCase="'RECONSTRUCTION'" i18n>Реконструкция</ng-container>
        <ng-container *ngSwitchCase="'NEW_CONSTRUCTION'" i18n>Новое строительство</ng-container>
        <ng-container *ngSwitchDefault>{{code}}</ng-container>
      </ng-container>
    </small>
    `,
    styles: `
      .tag {
        color: rgba(0, 0, 0, 0.85);
        font-variant: tabular-nums;
        list-style: none;
        font-feature-settings: "tnum";
        height: auto;
        margin-right: 8px;
        padding: 0 7px;
        font-size: 12px;
        line-height: 20px;
        background: #fafafa;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        opacity: 1;
        transition: all 0.3s;
        display: inline-block;
      }
    `,
    imports: [
        CommonModule,
    ]
})
export class ProjectTypeViewComponent {

  @Input()
  code?: string;
}
